import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';

import {
    FETCH_PACE_PRO_ALGORITHM_CONFIG,
    FETCH_PACE_PRO_ALGORITHM_CONFIG_SUCCESS,
    FETCH_PACE_PRO_ALGORITHM_CONFIG_FAIL
} from '../actions/paceProBandActions.js';

export function* fetchPaceProAlgorithmConfigSaga(action) {
    try {
        const response = yield call(axios.get, `/web-data/pacepro/algorithm-config.json`, {
            baseURL: '/'
        });

        yield put({
            type: FETCH_PACE_PRO_ALGORITHM_CONFIG_SUCCESS,
            config: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PACE_PRO_ALGORITHM_CONFIG_FAIL
        });
    }
}

export const paceProAlgorithmSagas = [takeEvery(FETCH_PACE_PRO_ALGORITHM_CONFIG, fetchPaceProAlgorithmConfigSaga)];
